import React, { useState } from "react";
import { Box, Flex, Image, Text } from "theme-ui";
import PropTypes from "prop-types";
import { Icon } from '../atoms';
import { colors, typography } from '../../styles/theme';

const ListCard = ({
  iconName,
  title,
  isChevronRequired,
  hoverTextColor,
  hoverBgColor,
  customStyles,
  isBorder,
  imageUrl,
}) => {
  const [colorList, setColorList] = useState({
    backgroundColor: colors.white,
    color: colors.black,
  });
  return (
    <Box
      sx={{
        py: "0.75rem",
        px: "0.75rem",
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        backgroundColor: colorList.backgroundColor,
        border: isBorder ? `1px solid ${colors.neutral200}` : "none",
        ...customStyles,
      }}
      onMouseOver={() => {
        setColorList({
          backgroundColor: hoverBgColor,
          color: hoverTextColor,
        });
      }}
      onMouseLeave={() => {
        setColorList({
          backgroundColor: colors.white,
          color: colors.black,
        });
      }}
    >
      <Flex sx={{ justifyContent: "space-between", minWidth: 0 }}>
        <Flex sx={{ alignItems: "center", minWidth: 0, flex: 1 }}>
          {!!iconName && (
            <Icon
              name={iconName}
              size={24}
              color={colors.primaryMain}
              customStyles={{ flexShrink: 0 }}
            />
          )}
          {imageUrl && (
            <Image
              src={imageUrl}
              alt="Product Category Logo"
              sx={{
                width: "1.5rem",
                height: "1.5rem",
                flexShrink: 0,
              }}
            />
          )}
          <Text
            sx={{
              ...(title === "Pricing" || title === "Customers" || title === "Harga"
                ? typography.h6
                : typography.textMd500),
              ml: "0.69rem",
              color: colorList.color,
              whiteSpace: "normal",
              wordBreak: "break-word",
              minWidth: 0,
            }}
          >
            {title}
          </Text>
        </Flex>
        {!!isChevronRequired && <Icon name={"ChevronRight"} size={24} />}
      </Flex>
    </Box>
  );
};

ListCard.propTypes = {
  iconName: PropTypes.string,
  title: PropTypes.string.isRequired,
  isChevronRequired: PropTypes.bool,
  customStyles: PropTypes.object,
  hoverTextColor: PropTypes.string,
  hoverBgColor: PropTypes.string,
  isBorder: PropTypes.bool,
};

ListCard.defaultProps = {
  iconName: "",
  title: "list card",
  isChevronRequired: true,
  customStyles: {},
  hoverTextColor: colors.black,
  hoverBgColor: colors.white,
  isBorder: false,
};

export default ListCard;
